import type { User } from 'features/auth';

export const canViewAiChat = ({ viewer }: { viewer: User }) => Boolean(viewer.nodeUserData.roles.bigheartStaff);
